// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ymvudtjuedkffjhopmxb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InltdnVkdGp1ZWRrZmZqaG9wbXhiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA1MDUyNTAsImV4cCI6MjA3NjA4MTI1MH0.bGU0_sdfX4ZqU01fs791xA8q8Q-T2s0UlBH13vE5w54";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});